"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = React.createElement;
function SvgComponent(props) {
  return __jsx("svg", (0, _extends2.default)({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), __jsx("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, __jsx("path", {
    d: "M1.5 46.526a11.022 11.022 0 009-3 9.094 9.094 0 0013.5 0 9.094 9.094 0 0013.5 0 11.022 11.022 0 009 3M43.514 40.542a12.456 12.456 0 002.858-3.908A1.5 1.5 0 0045 34.526H3a1.5 1.5 0 00-1.372 2.108A12.91 12.91 0 005.2 41.182",
    strokeWidth: 3
  }), __jsx("path", {
    d: "M22.5 34.526V4.06a2.534 2.534 0 00-4.568-1.512L4.542 23.2A1.5 1.5 0 005.8 25.522l16.696-.024M31.262 11.822a1.5 1.5 0 00-2.762.812v15.892h10.752a1.502 1.502 0 001.262-2.312z",
    strokeWidth: 3
  })));
}
var _default = exports.default = SvgComponent;